(() => {
  if (customElements.get('faqs-item')) return;

  class HaloFAQs extends HTMLElement {
    constructor() {
      super();

      this.filter = this.querySelector('[data-faqs-filter-wrap]');
      this.headers = Array.from(this.querySelectorAll('.card-header'));

      if (this.filter) {
        this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
        this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
        this.filterDropdownArrow = this.filter.querySelector('[data-dropdown-arrow]');

        if (this.filterToggle && this.filterDropdown) {
          this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));

          this.filterDropdown.querySelectorAll('li').forEach((filterOption) => {
            filterOption.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
          });
        }
      }

      this.headers.forEach((headerButton) => {
        headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
      });

      document.addEventListener('click', this.onDocumentClick.bind(this));
      window.addEventListener('resize', this.onResize.bind(this));
    }

    onClickFilterHandler(event) {
      event.stopPropagation();

      const isOpen = this.filterDropdown.classList.toggle('is-show');

      if (this.filterDropdownArrow) {
        this.filterDropdownArrow.classList.toggle('active', isOpen);
      }

      this.filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    onClickFilterButtonHandler(event) {
      const option = event.target.closest('li');
      if (!option || option.classList.contains('is-active')) return;

      const filterValue = option.getAttribute('data-value');
      const optionText = option.innerText.trim();

      const selectedText = this.filterToggle.querySelector('.text');
      if (selectedText) {
        selectedText.innerText = optionText;
      }

      this.filterDropdown.querySelectorAll('li').forEach((element) => {
        element.classList.remove('is-active');
      });

      option.classList.add('is-active');

      this.querySelectorAll('.faqs-paragraph').forEach((paragraph) => {
        const matches = !filterValue || paragraph.id === filterValue;

        paragraph.classList.toggle('is-hidden', !matches);
        paragraph.classList.toggle('is-active', Boolean(filterValue) && matches);
      });

      this.closeFilter();
    }

    onClickHeaderButtonHandler(event) {
      const button = event.currentTarget;
      const content = button.nextElementSibling;
      if (!content) return;

      const shouldOpen = button.classList.contains('collapsed');

      this.headers.forEach((otherButton) => {
        if (otherButton !== button) {
          this.closeAccordion(otherButton);
        }
      });

      if (shouldOpen) {
        this.openAccordion(button);
      } else {
        this.closeAccordion(button);
      }
    }

    openAccordion(button) {
      const content = button.nextElementSibling;
      if (!content) return;

      button.classList.remove('collapsed');
      button.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = `${content.scrollHeight}px`;
    }

    closeAccordion(button) {
      const content = button.nextElementSibling;
      if (!content) return;

      button.classList.add('collapsed');
      button.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = null;
    }

    closeFilter() {
      if (!this.filterDropdown || !this.filterToggle) return;

      this.filterDropdown.classList.remove('is-show');

      if (this.filterDropdownArrow) {
        this.filterDropdownArrow.classList.remove('active');
      }

      this.filterToggle.setAttribute('aria-expanded', 'false');
    }

    onDocumentClick(event) {
      if (!this.filter || this.filter.contains(event.target)) return;
      this.closeFilter();
    }

    onResize() {
      this.headers.forEach((button) => {
        if (!button.classList.contains('collapsed')) {
          const content = button.nextElementSibling;
          if (content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
          }
        }
      });
    }
  }

  customElements.define('faqs-item', HaloFAQs);
})();